import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const docTypeLocaleModule: LocaleModule = {
  name: "docType",
  messages: { en: en, it: it },
};
